<nz-modal
  [nzVisible]="isVisible()"
  [nzTitle]="nzTitle"
  nzCentered
  [nzWidth]="showTable ? '90%' : '500px'"
  [nzFooter]="showTable ? modalFooter : null"
  [nzOkText]="showTable ? null : '关闭'"
  [nzCancelText]="null"
  nzOkType="default"
  (nzOnCancel)="onCancel()"
  (nzOnOk)="showTable ? null : onCancel()"
  [nzMaskClosable]="false"
>
  <ng-template #nzTitle>
    <div class="flex items-center">{{ config().title }}</div>
  </ng-template>
  <ng-container *nzModalContent>
    @if (!showTable) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1 text-xs text-[#00000073]">
          <div>
            <div>{{ config().description }}</div>
            @if (getTemplateName()) {
              <div class="mb-1 ml-[15px] mt-1 text-[#00000073]">
                {{ getTemplateName() }}
                <a [href]="config().templateUrl" target="_blank" class="ml-1">
                  点击下载
                </a>
              </div>
            }
          </div>
          <div>2、上传填写好的文件</div>
        </div>

        <div>
          <nz-upload
            nzType="drag"
            [nzLimit]="1"
            nzAccept=".xls,.xlsx,.csv"
            [nzShowUploadList]="false"
            [nzBeforeUpload]="handleFile.bind(this)"
          >
            <p class="mb-3">
              <span nz-icon nzType="inbox" class="text-3xl" style="color: #f08784"></span>
            </p>
            <p class="ant-upload-text">点击上传</p>
            <p class="ant-upload-hint">支持.xlsx和.csv格式</p>
          </nz-upload>
        </div>

        @if (isDemo && showDemoEntry) {
          <div
            class="rounded border border-dashed border-[#f08784] bg-[#fff7f7] px-3 py-2"
          >
            <div class="mb-2 text-xs text-[#00000073]">
              演示环境：这里备好了一份预置的假表格（5 行，计划名以「表格-」开头）。
              点下面的按钮等同于上传了它，后面照样走识别 → 校验 → 提交。
            </div>
            <button nz-button nzType="primary" (click)="loadDemoTable()">
              载入演示表格
            </button>
          </div>
        }
      </div>
    }
    @if (showTable && tableHeaders.length > 0 && tableData.length > 0) {
      <div style="max-height: 78vh; overflow-y: auto">
        @if (errorMessages.length > 0) {
          <div class="mb-4">
            <nz-collapse class="mb-4">
              <nz-collapse-panel [nzHeader]="errorHeader" [nzActive]="true" nzShowArrow>
                <ng-template #errorHeader>
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <span class="text-red-500"
                        >表格校验失败：以下数据存在问题，请在下方表格中进行编辑修正，修正完成后点击重新校验</span
                      >
                      <span class="text-sm font-normal text-gray-500"
                        >（共 {{ errorMessages.length }} 条）</span
                      >
                    </div>
                  </div>
                </ng-template>
                <div class="max-h-[110px] overflow-auto">
                  @for (msg of errorMessages; track $index) {
                    <div>{{ $index + 1 }}. {{ msg }}</div>
                  }
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        } @else if (hasVerified && errorMessages.length === 0) {
          <div class="mb-4">
            <div class="text-sm text-green-500">
              表格校验成功，请点击提交按钮提交数据，提交后将跳转至任务列表
            </div>
          </div>
        }
        <nz-table
          sticky
          [nzData]="tableData"
          [nzPageIndex]="pageIndex"
          [nzPageSize]="pageSize"
          [nzTotal]="total"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="[10, 20, 50, 100]"
          [nzScroll]="{ x: 'max-content' }"
          [nzNoResult]="noResultTpl"
          [nzShowTotal]="totalTemplate"
          (nzPageIndexChange)="onPageIndexChange($event)"
          (nzPageSizeChange)="onPageSizeChange($event)"
        >
          <thead>
            <tr>
              <th nzWidth="50px"></th>
              @for (header of tableHeaders; track header) {
                <th [nzWidth]="getHeaderWidth(header)" style="white-space: nowrap">
                  {{ header }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of displayTableData; track $index; let rowIndex = $index) {
              <tr>
                <td class="text-center">
                  {{ (pageIndex - 1) * pageSize + rowIndex + 1 }}
                </td>
                @for (header of tableHeaders; track header) {
                  <td
                    class="editable-cell"
                    (mouseenter)="
                      !isEditing(row, header) && (hoveredCell = { row, header })
                    "
                    (mouseleave)="!isEditing(row, header) && (hoveredCell = null)"
                  >
                    @if (isEditing(row, header)) {
                      <!-- 编辑模式 -->
                      <div class="edit-container">
                        <input
                          nz-input
                          [(ngModel)]="editingValue"
                          (blur)="saveEdit()"
                          (keydown.enter)="saveEdit()"
                          (keydown.escape)="cancelEdit()"
                          class="edit-input"
                          autofocus
                        />
                      </div>
                    } @else {
                      <!-- 显示模式 -->
                      <div class="cell-content name-container">
                        <span class="name-text">{{ row[header] || '' }}</span>
                        <span
                          nz-icon
                          nzType="edit"
                          nzTheme="outline"
                          class="edit-icon"
                          [class.show]="
                            hoveredCell?.row === row && hoveredCell?.header === header
                          "
                          (click)="startEdit(row, header); $event.stopPropagation()"
                        ></span>
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
          <ng-template #noResultTpl>
            <app-empty-table />
          </ng-template>
          <ng-template #totalTemplate let-range="range" let-total>
            <app-table-total [range]="range" [total]="total"></app-table-total>
          </ng-template>
        </nz-table>
      </div>
    }
  </ng-container>
  <ng-template #modalFooter>
    <div class="flex justify-end gap-2">
      <button
        nz-button
        nzType="default"
        (click)="goBack()"
        [nzLoading]="isSubmitting || isVerifying"
      >
        返回上一步
      </button>
      @if (errorMessages.length === 0) {
        <button
          nz-button
          nzType="primary"
          (click)="handleSubmit()"
          [nzLoading]="isSubmitting"
        >
          提交
        </button>
      } @else {
        <button
          nz-button
          nzType="primary"
          (click)="verifyTableData()"
          [nzLoading]="isVerifying"
        >
          重新校验
        </button>
      }
    </div>
  </ng-template>
</nz-modal>
